/**
 * Internationalization (i18n) Module
 * Supports Russian and English languages
 */

const translations = {
    ru: {
        // Connection
        'connect': 'Подключить',
        'disconnect': 'Отключить',
        'select-port': 'Выберите порт',
        'connecting': 'Подключение...',
        'connected': 'Подключено',
        'disconnected': 'Отключено',
        'connection-error': 'Ошибка подключения',
        'port-closed': 'Порт закрыт',
        'no-ports': 'Порты не найдены',

        // Tabs
        'pins': 'Пины',
        'ws2812': 'WS2812',
        'dht-sensors': 'DHT Датчики',
        'terminal': 'Терминал',
        'monitor': 'Монитор',

        // Pins Panel
        'pin-configuration': 'Конфигурация пинов',
        'read-all': 'Прочитать все',
        'save-to-flash': 'Сохранить во Flash',
        'pin': 'Пин',
        'gpio': 'GPIO',
        'mode': 'Режим',
        'value': 'Значение',
        'actions': 'Действия',
        'set': 'Уст.',
        'read': 'Чит.',
        'pwm-frequency': 'Частота PWM, Гц:',

        // Mode Reference
        'mode-reference': 'Справочник режимов',
        'mode-input': 'Вход (цифровой)',
        'mode-output': 'Выход (цифровой)',
        'mode-pwm': 'ШИМ (0-100%)',
        'mode-analog': 'АЦП (0-4095)',
        'mode-dht': 'DHT (температура/влажность)',
        'mode-ws2812': 'WS2812 (только пин 4)',
        'mode-capture': 'Захват частоты',
        'mode-uart-tx': 'UART TX (только пин 2)',
        'mode-uart-rx': 'UART RX (только пин 6)',
        'mode-unchanged': 'Не изменять (пины 8 и 10 / SWD)',

        // WS2812 Panel
        'led-count': 'Кол-во LED:',
        'off': 'Выкл',
        'rainbow': 'Радуга',
        'color-palette': 'Палитра цветов (256)',
        'manual-hex': 'HEX последовательность:',
        'send': 'Отправить',
        'preview': 'Предпросмотр',
        'ws2812-mode-required': 'Пин 4 должен быть в режиме WS2812',

        // DHT Panel
        'status': 'Статус',
        'temperature': 'Температура',
        'humidity': 'Влажность',
        'last-update': 'Последнее обновление',
        'auto-update': 'Автообновление',
        'ok': 'ОК',
        'error': 'Ошибка',
        'no-data': 'Нет данных',
        'not-dht': 'Не DHT',

        // Terminal
        'clear': 'Очистить',
        'enter-command': 'Введите команду...',

        // Monitor
        'start': 'Старт',
        'stop': 'Стоп',
        'monitored-pins': 'Мониторинг пинов:',
        'data-type': 'Тип данных:',
        'digital': 'Цифровой',
        'analog': 'Аналоговый',
        'capture': 'Захват',

        // Settings
        'settings': 'Настройки',
        'theme': 'Тема',
        'auto': 'Авто',
        'dark': 'Тёмная',
        'light': 'Светлая',
        'language': 'Язык',

        // Errors and Messages
        'not-supported': 'Не поддерживается',
        'webserial-not-supported': 'Ваш браузер не поддерживает Web Serial API.',
        'use-chrome': 'Используйте Chrome, Edge или Opera версии 89+.',
        'saved-to-flash': 'Сохранено во Flash',
        'flash-save-error': 'Ошибка сохранения во Flash',
        'command-sent': 'Команда отправлена',
        'command-error': 'Ошибка команды',
        'timeout': 'Таймаут',
        'invalid-value': 'Неверное значение',
        'mode-not-settable': 'Этот режим не поддерживает установку значений',
        'pin-conflict': 'Конфликт пинов',
        'capture-conflict': 'Пины 4 и 5 не могут одновременно быть в режиме Capture',
    },
    en: {
        // Connection
        'connect': 'Connect',
        'disconnect': 'Disconnect',
        'select-port': 'Select port',
        'connecting': 'Connecting...',
        'connected': 'Connected',
        'disconnected': 'Disconnected',
        'connection-error': 'Connection error',
        'port-closed': 'Port closed',
        'no-ports': 'No ports found',

        // Tabs
        'pins': 'Pins',
        'ws2812': 'WS2812',
        'dht-sensors': 'DHT Sensors',
        'terminal': 'Terminal',
        'monitor': 'Monitor',

        // Pins Panel
        'pin-configuration': 'Pin Configuration',
        'read-all': 'Read All',
        'save-to-flash': 'Save to Flash',
        'pin': 'Pin',
        'gpio': 'GPIO',
        'mode': 'Mode',
        'value': 'Value',
        'actions': 'Actions',
        'set': 'Set',
        'read': 'Read',
        'pwm-frequency': 'PWM frequency, Hz:',

        // Mode Reference
        'mode-reference': 'Mode Reference',
        'mode-input': 'Input (digital)',
        'mode-output': 'Output (digital)',
        'mode-pwm': 'PWM (0-100%)',
        'mode-analog': 'ADC (0-4095)',
        'mode-dht': 'DHT (temperature/humidity)',
        'mode-ws2812': 'WS2812 (pin 4 only)',
        'mode-capture': 'Frequency Capture',
        'mode-uart-tx': 'UART TX (pin 2 only)',
        'mode-uart-rx': 'UART RX (pin 6 only)',
        'mode-unchanged': 'Keep unchanged (pins 8 and 10 / SWD)',

        // WS2812 Panel
        'led-count': 'LED count:',
        'off': 'Off',
        'rainbow': 'Rainbow',
        'color-palette': 'Color Palette (256)',
        'manual-hex': 'HEX sequence:',
        'send': 'Send',
        'preview': 'Preview',
        'ws2812-mode-required': 'Pin 4 must be in WS2812 mode',

        // DHT Panel
        'status': 'Status',
        'temperature': 'Temperature',
        'humidity': 'Humidity',
        'last-update': 'Last Update',
        'auto-update': 'Auto Update',
        'ok': 'OK',
        'error': 'Error',
        'no-data': 'No data',
        'not-dht': 'Not DHT',

        // Terminal
        'clear': 'Clear',
        'enter-command': 'Enter command...',

        // Monitor
        'start': 'Start',
        'stop': 'Stop',
        'monitored-pins': 'Monitored pins:',
        'data-type': 'Data type:',
        'digital': 'Digital',
        'analog': 'Analog',
        'capture': 'Capture',

        // Settings
        'settings': 'Settings',
        'theme': 'Theme',
        'auto': 'Auto',
        'dark': 'Dark',
        'light': 'Light',
        'language': 'Language',

        // Errors and Messages
        'not-supported': 'Not Supported',
        'webserial-not-supported': 'Your browser does not support Web Serial API.',
        'use-chrome': 'Please use Chrome, Edge, or Opera version 89+.',
        'saved-to-flash': 'Saved to Flash',
        'flash-save-error': 'Flash save error',
        'command-sent': 'Command sent',
        'command-error': 'Command error',
        'timeout': 'Timeout',
        'invalid-value': 'Invalid value',
        'mode-not-settable': 'This mode does not support setting values',
        'pin-conflict': 'Pin conflict',
        'capture-conflict': 'Pins 4 and 5 cannot both be in Capture mode',
    }
};

class I18n {
    constructor() {
        this._lang = this._detectLanguage();
        this._listeners = [];
    }

    _detectLanguage() {
        // Check localStorage first
        const stored = localStorage.getItem('gpio_extender_locale');
        if (stored && translations[stored]) {
            return stored;
        }

        // Detect from browser
        const candidates = new Set([
            ...(navigator.languages || []),
            navigator.language,
        ].filter(Boolean));

        for (const locale of candidates) {
            const langCode = locale.trim().toLowerCase().split(/[-_]/)[0];
            if (langCode === 'ru') return 'ru';
        }

        return 'en';
    }

    get lang() {
        return this._lang;
    }

    set lang(value) {
        if (translations[value] && value !== this._lang) {
            this._lang = value;
            localStorage.setItem('gpio_extender_locale', value);
            this._notifyListeners();
        }
    }

    t(key) {
        return translations[this._lang]?.[key] || translations['en']?.[key] || key;
    }

    onChange(callback) {
        this._listeners.push(callback);
        return () => {
            const index = this._listeners.indexOf(callback);
            if (index > -1) {
                this._listeners.splice(index, 1);
            }
        };
    }

    _notifyListeners() {
        for (const listener of this._listeners) {
            try {
                listener(this._lang);
            } catch (error) {
                console.error('I18n listener error:', error);
            }
        }
    }

    /**
     * Update all elements with data-i18n attribute
     */
    updateDOM() {
        document.querySelectorAll('[data-i18n]').forEach(el => {
            const key = el.getAttribute('data-i18n');
            const translated = this.t(key);
            if (el.tagName === 'INPUT' && el.placeholder) {
                el.placeholder = translated;
            } else {
                el.textContent = translated;
            }
        });
    }
}

// Singleton instance
const i18n = new I18n();

// Shorthand function
export function t(key) {
    return i18n.t(key);
}

export default i18n;
